import {
  FormEventHandler,
  FunctionComponent,
  useContext,
  useEffect, useState,
} from 'react'
import { useActor, useMachine } from '@xstate/react'
import posthog from 'posthog-js'
import { CampaignContext } from '../src/state/CampaignContext'
import { ValidationInterpreter } from '../src/machines/validationMachine'
import { DonationInterpreter } from '../src/machines/donationMachine'
import { ProductInterpreter } from '../src/machines/productMachine'
import { addToCartMachine } from '../src/machines/addToCartMachine'
import { DonationGrid } from './DonationGrid'
import { SizeSelect } from './SizeSelect'
import styles from './AddToCartForm.module.css'

export const AddToCartForm: FunctionComponent = () => {
  const campaign = useContext(CampaignContext)
  const sizes = campaign.offer.itemOffered.sizes

  const [state, send] = useMachine(addToCartMachine, { context: { campaign } })
  const [validationState, validationSend] = useActor(
    state.children.validation as ValidationInterpreter
  )
  const productService = state.children.product as ProductInterpreter
  const donationService = state.children.donation as DonationInterpreter

  const addToCart: FormEventHandler = (event) => {
    event.preventDefault()

    send({ type: 'SUBMIT' })
  }

  const [addYourDonationText, setAddYourDonationText] = useState('Add your donation!')

  useEffect(() => {
    posthog.onFeatureFlags(() => {
      if (posthog.getFeatureFlag('test-add-your-donation') === 'remove-exclamation-point') {
        setAddYourDonationText('Add your donation')
      } else {
        setAddYourDonationText('Add your donation!')
      }
    })
  }, [])

  return (
    <form onSubmit={addToCart}>
      <div className="stack-l gap-s2">
        <div className="stack-l gap-s_2">
          <h3>{addYourDonationText}</h3>
          <p>{campaign.donationCall}</p>
          {campaign.runningTotal && <p>{campaign.runningTotal}</p>}
          <DonationGrid service={donationService} />
        </div>

        <div className={`grid-l ${styles.submitRow}`}>
          <SizeSelect
            sizes={sizes}
            service={productService}
            onFocus={() => validationSend('CLEAR')}
          />

          <div className="grid-l relative">
            {validationState.value === 'invalid' && (
              <div className={styles.errorMessage}>
                <p>{validationState.context.errorMessage}</p>
              </div>
            )}
            <button
              className={`${styles.addToCart} button button-primary`}
              type="submit"
            >
              Add to bag
            </button>
          </div>
        </div>
      </div>
    </form>
  )
}
